"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _redux = require("redux");
var _userReducer = _interopRequireDefault(require("./user/userReducer"));
var _questionnaireReducer = _interopRequireDefault(require("./questionnaire/questionnaireReducer"));
var _recommendationReducer = _interopRequireDefault(require("./recommendation/recommendationReducer"));
var _productCatalogReducer = _interopRequireDefault(require("./productCatalog/productCatalogReducer"));
var _uiReducer = _interopRequireDefault(require("./ui/uiReducer"));
var _widgetReducer = _interopRequireDefault(require("./widget/widgetReducer"));
var _errorReducer = _interopRequireDefault(require("./error/errorReducer"));
var _upsellReducer = _interopRequireDefault(require("./upsell/upsellReducer"));
var _comparisonReducer = _interopRequireDefault(require("./comparison/comparisonReducer"));
var _shareRecommendationReducer = _interopRequireDefault(require("./shareRecommendation/shareRecommendationReducer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var initialState = {
  user: {},
  questionnaire: {},
  recommendation: {},
  productCatalog: {},
  ui: {},
  widget: {},
  error: {},
  upsell: {},
  comparison: {},
  shareRecommendation: {}
};
exports.initialState = initialState;
var appReducer = (0, _redux.combineReducers)({
  user: _userReducer.default,
  questionnaire: _questionnaireReducer.default,
  recommendation: _recommendationReducer.default,
  productCatalog: _productCatalogReducer.default,
  ui: _uiReducer.default,
  widget: _widgetReducer.default,
  error: _errorReducer.default,
  upsell: _upsellReducer.default,
  comparison: _comparisonReducer.default,
  shareRecommendation: _shareRecommendationReducer.default
});
var _default = appReducer;
exports.default = _default;